class CartRemoveButton extends HTMLElement {
    constructor() {
        super()

        this.addEventListener('click', (event) => {
            event.preventDefault()
            const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items')
            cartItems.updateQuantity(this.dataset.index, 0)
        })
    }
}

customElements.define('cart-remove-button', CartRemoveButton)

class CartItems extends HTMLElement {
    constructor() {
        super()
        this.lineItemStatusElement =
            document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus')

        const debouncedOnChange = debounce((event) => {
            this.onChange(event)
        }, ON_CHANGE_DEBOUNCE_TIMER)

        this.addEventListener('change', debouncedOnChange.bind(this))
    }

    cartUpdateUnsubscriber = undefined

    connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'cart-items') {
                return
            }
            this.onCartUpdate()
        })
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber()
        }
    }

    onChange(event) {
        if(!isNaN(Number(event.target.value)) && event.target.type === 'number')
            this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId)
    }

    onCartUpdate() {
        if (this.tagName === 'CART-DRAWER-ITEMS') {
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html')
                    // const selectors = ['cart-drawer-items', '.cart-drawer__footer']
                    const selectors = ['cart-drawer-items']
                    for (const selector of selectors) {
                        const targetElement = document.querySelector(selector)
                        const sourceElement = html.querySelector(selector)
                        if (targetElement && sourceElement) {
                            targetElement.replaceWith(sourceElement)
                        }
                    }
                })
                .catch((e) => {
                    console.error(e)
                })
        } else {
            fetch(`${routes.cart_url}?section_id=main-cart-items`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html')
                    const sourceQty = html.querySelector('cart-items')
                    this.innerHTML = sourceQty.innerHTML
                })
                .catch((e) => {
                    console.error(e)
                })
        }
    }

    getSectionsToRender() {
        return [
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items').dataset.id,
                selector: '.js-contents'
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            }
            // {
            // 	id: 'main-cart-footer',
            // 	section: document.getElementById('main-cart-footer').dataset.id,
            // 	selector: '.js-contents'
            // }
        ]
    }

    updateQuantity(line, quantity, name, variantId) {
        this.enableLoading(line)

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        })

        let hasFailed = false

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text()
            })
            .then((state) => {
                const parsedState = JSON.parse(state)

                if (parsedState.errors != undefined) {
                    hasFailed = true
                }


                const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`)
                const items = document.querySelectorAll('.cart-item')

                if (parsedState.errors) {
                    quantityElement.value = quantityElement.getAttribute('value')
                    this.updateLiveRegions(line, parsedState.errors)
                    return
                }

                this.classList.toggle('is-empty', parsedState.item_count === 0)

                this.getSectionsToRender().forEach((section) => {
                    const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector
                    )
                })
                const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined
                let message = ''
                if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
                    if (typeof updatedValue === 'undefined') {
                        message = window.cartStrings.error
                    } else {
                        message = window.cartStrings.quantityError.replace('[quantity]', updatedValue)
                    }
                }
                this.updateLiveRegions(line, message)

                const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`)
                if (lineItem && lineItem.querySelector(`[name="${name}"]`))
                    lineItem.querySelector(`[name="${name}"]`).focus()

                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId })
            })
            .catch((e) => {
                this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'))
                const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors')
                console.log(e)
                errors.textContent = window.cartStrings.error
            })
            .finally((e) => {
                this.disableLoading(line)

                const currency = localStorage.getItem('selectedCurrency')

              
                if (currency === null || currency === 'DKK' || hasFailed) {
                    // If DKK is selected, do nothing and display the original prices
                    return
                }

                const rates = JSON.parse(localStorage.getItem('currencyRates'))
                const dkkToEur = rates?.EUR // Conversion rate from DKK to EUR

                const pricesDrawer = document.querySelectorAll('cart-drawer-items .money') // Assuming all prices have the class 'money'
                const pricesCart = document.querySelectorAll('cart-items .money')

                pricesDrawer.forEach(function(price) {
                    // Get the innerHTML of the element and strip any non-numeric characters except the decimal point
                    const originalPriceStr = price.innerHTML.replace(/[^\d.,]/g, '').replace(',', '.')
                    const originalPrice = parseFloat(originalPriceStr)

                    if (!isNaN(originalPrice)) {
                        const convertedPrice = originalPrice * dkkToEur

                        const formattedPrice = new Intl.NumberFormat('de-DE', {
                            style: 'currency',
                            currency: currency
                        }).format(convertedPrice).replace('.', '')

                        price.textContent = formattedPrice
                    } else {
                        console.error('Failed to parse original price:', originalPriceStr)
                    }
                })

                pricesCart.forEach(function(price) {
                    // Get the innerHTML of the element and strip any non-numeric characters except the decimal point
                    const originalPriceStr = price.innerHTML.replace(/[^\d.,]/g, '').replace(',', '.')
                    const originalPrice = parseFloat(originalPriceStr)

                    if (!isNaN(originalPrice)) {
                        const convertedPrice = originalPrice * dkkToEur
                      
                        price.textContent = new Intl.NumberFormat('de-DE', {
                            style: 'currency',
                            currency: currency
                        }).format(convertedPrice).replace('.', '')
                    } else {
                        console.error('Failed to parse original price:', originalPriceStr)
                    }
                })

            })
    }

    updateLiveRegions(line, message) {
        const lineItemError =
            document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`)
        if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message.includes('You can\'t add more') ? 'You can\'t add more to the cart.' : message

        if (this.lineItemStatusElement != null) {
            this.lineItemStatusElement.setAttribute('aria-hidden', true)
        }

        const cartStatus =
            document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText')

        if (cartStatus != null) {
            cartStatus.setAttribute('aria-hidden', false)
        }

        setTimeout(() => {
            if (cartStatus != null) {
                cartStatus.setAttribute('aria-hidden', true)
            }
        }, 1000)
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
    }

    enableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
        if (mainCartItems !== null)
            mainCartItems.classList.add('cart__items--disabled')

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`)
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'))

        document.activeElement.blur()
        if (this.lineItemStatusElement !== null)
            this.lineItemStatusElement.setAttribute('aria-hidden', false)
    }

    disableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
        mainCartItems.classList.remove('cart__items--disabled')

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`)
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`)

        cartItemElements.forEach((overlay) => overlay.classList.add('hidden'))
        cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'))
    }
}

customElements.define('cart-items', CartItems)

if (!customElements.get('cart-note')) {
    customElements.define(
        'cart-note',
        class CartNote extends HTMLElement {
            constructor() {
                super()
                this.note = ''
                this.giftDate = ''
                this.giftWrapping = false

                this.addEventListener(
                    'input',
                    debounce((event) => {
                        this.handleInput(event)
                        this.updateCartNote()
                        this.sendUpdate()
                    }, ON_CHANGE_DEBOUNCE_TIMER)
                )
            }

            handleInput(event) {
                switch (event.target.id) {
                    case 'notes':
                        this.note = event.target.value
                        break
                    case 'gift-date':
                        this.giftDate = event.target.value
                        break
                    case 'gift-wrapping':
                        this.giftWrapping = event.target.checked
                        break
                }
            }

            updateCartNote() {
                this.cartNote = this.note  // Start with the main note

                // Append gift date if applicable
                if (this.giftDate)
                    this.cartNote += ` – Gift Date: ${this.giftDate}`

                // Append gift wrapping note if applicable
                if (this.giftWrapping)
                    this.cartNote += ` – Gift should be wrapped`
            }

            sendUpdate() {
                const body = JSON.stringify({ note: this.cartNote })
                fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
                    .then(response => console.log('Cart updated successfully'))
                    .catch(error => console.error('Error updating cart:', error));
            }
        }
    )
}
